import React from "react";
import { useNavigate } from "react-router-dom";


const SafetyTraining = ()=>
{

const navigate = useNavigate();

const scrollToTop = (location) => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(location)
  };

const openVideo = (videoUrl) =>
{
    console.log(videoUrl)
    window.open(videoUrl, "_blank", "width=800, height=600")
}



    return (
        
        <div className="module-table">
        <div className="module-title">
            <p>Safety Training Sample videos</p>
            </div>

     
     <ul>
        
     <li>

<img
className="module"
src="\mainImages\playbutton\driving-pro-black-top.png"
alt="Drivin Pro Blacktop"
width="300"
height="400"
onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Black+Top+Driving+Pro.mp4')} />

</li>
  <li>
    <img className="module" src="\mainImages\playbutton\lsr-aware.png" alt ="Life Saving Rules" width="300" height="auto" 
    onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/LSR+Aware.mp4')} />

</li>
  <li>
    <img className="module" src="\mainImages\playbutton\driving-pro-graded-road.png" alt ="Driving Pro Graded Road" width="300" height="auto" 
    onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Graded+Road+Driving+Pro.mp4')} />

</li>
<li>
    <img className="module" src="\mainImages\playbutton\lsr-roads.png" alt ="Life Saving Rules" width="300" height="400" 
                    onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Life-Saving+Rules+Road.mp4')} />
</li>
<li>
    <img className="module" src="\mainImages\playbutton\lsr-pro.png" alt ="Life Saving Pro" width="300" height="auto" 
                    onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/LSR+Pro.mp4')} />

</li>
 <li>
    <img className="module" src="\mainImages\playbutton\driving-aware-all-roads.png" alt ="driving Aware All road" width="300" height="auto" 
                    onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Driving+Aware.mp4')} />

</li>
 <li>
    <img className="module" src="\mainImages\playbutton\process-safety.png" alt ="Process Safety" width="300" height="auto"  
    onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/VIRSAT+Process+Safety.mp4')} />
</li>

            {/* DUPLICATE */}
            <li>

            <img
            className="module"
            src="\mainImages\playbutton\driving-pro-black-top.png"
            alt="Drivin Pro Blacktop"
            width="300"
            height="auto"
            onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Black+Top+Driving+Pro.mp4')} />

            </li>
              <li>
                <img className="module" src="\mainImages\playbutton\lsr-aware.png" alt ="Life Saving Rules" width="300" height="auto" 
                onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/LSR+Aware.mp4')} />

            </li>
              <li>
                <img className="module" src="\mainImages\playbutton\driving-pro-graded-road.png" alt ="Driving Pro Graded Road" width="300" height="auto" 
                onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Graded+Road+Driving+Pro.mp4')} />

            </li>
            <li>
                <img className="module" src="\mainImages\playbutton\lsr-roads.png" alt ="Life Saving Rules" width="300" height="auto" 
                                onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Life-Saving+Rules+Road.mp4')} />
            </li>
            <li>
                <img className="module" src="\mainImages\playbutton\lsr-pro.png" alt ="Life Saving Pro" width="300" height="auto" 
                                onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/LSR+Pro.mp4')} />

            </li>
             <li>
                <img className="module" src="\mainImages\playbutton\driving-aware-all-roads.png" alt ="driving Aware All road" width="300" height="auto" 
                                onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/Driving+Aware.mp4')} />
  
            </li>
             <li>
                <img className="module" src="\mainImages\playbutton\process-safety.png" alt ="Process Safety" width="300" height="auto"  
                onClick={() => openVideo('https://webglbucketvideos.s3.me-south-1.amazonaws.com/VIRSAT+Process+Safety.mp4')} />
            </li>

        </ul>
             <button className="body-button" onClick={()=>scrollToTop('/pclicense')}>Get Access</button>

        </div>


    );
}

export default SafetyTraining;